import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { securePost } from '../../config/api';
import { SaveCancel } from '../../components/PrimaryButton';
import Input from '../../components/Input';
import SnackbarNotification from '../../components/SnackbarNotification';

const CancelSubscriptionPopup = ({
  open,
  onClose,
  tenantId,
  onSuccess,
}) => {
  const { t } = useTranslation();
  const [formValues, setFormValues] = useState({
    cancellationReason: '',
    cancellationNotes: '',
  });
  const [saving, setSaving] = useState(false);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

  const showSnackbar = (message, severity = 'success') => {
    setSnackbar({ open: true, message, severity });
  };

  useEffect(() => {
    if (open) {
      setFormValues({
        cancellationReason: '',
        cancellationNotes: '',
      });
    }
  }, [open]);

  const handleChange = (name, value) => {
    setFormValues(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async () => {
    if (tenantId == null || tenantId === '') {
      showSnackbar(t('errors.generic'), 'error');
      return;
    }
    setSaving(true);
    try {
      const payload = {
        cancellationReason: formValues.cancellationReason || undefined,
        cancellationNotes: formValues.cancellationNotes || undefined,
      };
      await securePost(`/tenants/${tenantId}/cancel`, payload, showSnackbar);
      showSnackbar(t('clientDetails.cancelSubscriptionSuccess') || 'Subscription cancelled', 'success');
      onSuccess?.();
      onClose();
    } catch (err) {
      console.error(err);
      showSnackbar(t('errors.generic'), 'error');
    } finally {
      setSaving(false);
    }
  };

  if (!open) return null;

  return (
    <>
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[1050]">
        <div className="bg-white rounded-xl p-6 w-11/12 max-w-lg">
          <h3 className="text-[22px] font-semibold text-[#38485C] mb-4">
            {t('clientDetails.cancelSubscriptionTitle') || 'Cancel subscription'}
          </h3>
          <div className="space-y-4">
            <Input
              label={t('clientDetails.cancellationReason')}
              name="cancellationReason"
              type="text"
              value={formValues.cancellationReason}
              onChange={(value) => handleChange('cancellationReason', value)}
            />
            <Input
              label={t('clientDetails.cancellationNotes')}
              name="cancellationNotes"
              type="text"
              value={formValues.cancellationNotes}
              onChange={(value) => handleChange('cancellationNotes', value)}
            />
          </div>
          <div className="flex justify-end gap-4 mt-6">
            <SaveCancel
              onSaveClick={() => !saving && handleSubmit()}
              onCancelClick={onClose}
            />
          </div>
        </div>
      </div>
      <SnackbarNotification
        open={snackbar.open}
        message={snackbar.message}
        severity={snackbar.severity}
        onClose={() => setSnackbar(prev => ({ ...prev, open: false }))}
      />
    </>
  );
};

export default CancelSubscriptionPopup;
